'use strict';

module.exports = function() {
    var $header = $(document).find('header.cc-header');
    var isHeaderTransparent = $header.data('header');

    //  Menu Opening and Closing

    $(document).on('click', '.js-menu-btn', function (event) {
        event.preventDefault();
        $header.toggleClass('cc-header--menuOpened');
        $('body').toggleClass('cc-blocked');
        if (window.isDesktop) {
            $(document).find('.js-headerOverlay').toggleClass('cc-header__overlay--active');
        }
        $(document).find('.cc-menu__item__link').removeClass('cc-menu__item__link--opacity');
        if (!$header.hasClass('cc-header--menuOpened')) {
            if (window.isMobile || window.isTablet) {
                $(document).find('.cc-menu__secondLevel').hide().removeClass('cc-menu__secondLevel--opened');
            } else {
                $(document).find('.cc-menu__secondLevel').removeClass('cc-menu__secondLevel--opened');
            }
        } else {
            if (window.isMobile || window.isTablet) {
                $(document).find('.cc-menu__secondLevel').show();
            }
        }
        // Remove Header Transparent when the menu is opened
        if (isHeaderTransparent) {
            if (window.isMobile || window.isTablet) {
                $header.toggleClass('cc-header--transparent');
            }
        }
    });

    $('.cc-header__overlay').on('click', function (event) {
        if ($header.hasClass('cc-header--menuOpened')) {
            if (window.isDesktop) {
                $(document).find('.js-headerOverlay').toggleClass('cc-header__overlay--active');
            }
        }
    });

    // Closing Menu from Desktop

    $(document).on('click', '.js-closeMenu, .cc-header__overlay', function (event) {
        event.preventDefault();
        $(document).find('.cc-header').removeClass('cc-header--menuOpened');
        $(document).find('.cc-menu__secondLevel').removeClass('cc-menu__secondLevel--opened');
        $('body').removeClass('cc-blocked');
        $(document).find('.cc-menu__item__link').removeClass('cc-menu__item__link--opacity');
        $(document).find('.cc-header__overlay').removeClass('cc-header__overlay--active');
    });

    // Second Level Menu Opening

    $(document).on('click', '.js-navLink', function (event) {
        event.preventDefault();
        var menuActionHeight = $(document).find('.cc-menu__action').outerHeight();
        if ($(this).hasClass('cc-hasChild')) {
            document.documentElement.style.setProperty('--menuActionHeight', menuActionHeight / 10 + 'rem');

            // Add Opacity to the Menu Voices not selected

            if (window.isDesktop) {
                $(this).removeClass('cc-menu__item__link--opacity');

                if (!$(this).hasClass('cc-menu__item__link--opacity')) {
                    $(document).find('.cc-menu__item__link').addClass('cc-menu__item__link--opacity');
                    $(this).removeClass('cc-menu__item__link--opacity');
                }
            }

            // Open the Second Level Menu Tab

            if (!$(this).next('.cc-menu__secondLevel').hasClass('cc-menu__secondLevel--opened')) {
                $(document).find('.cc-menu__secondLevel').removeClass('cc-menu__secondLevel--opened');
                $(this).next('.cc-menu__secondLevel').addClass('cc-menu__secondLevel--opened');
            }
        }
    });

    // Back CTA from Mobile & Tablet

    $(document).on('click', '.js-menuBack', function (event) {
        var secondLevelMenu = $(document).find('.cc-menu__secondLevel.cc-menu__secondLevel--opened');
        event.preventDefault();
        secondLevelMenu.removeClass('cc-menu__secondLevel--opened');
    });
};
